import { useCallback, useState } from "react"
import { Swiper as SwiperClass } from "swiper"

export const useSlider = () => {
  const [activeIndex, setActiveIndex] = useState(1)
  const [swiper1, setSwiper1] = useState<SwiperClass>()
  const [swiper2, setSwiper2] = useState<SwiperClass>()

  const handleSetSwiperInstance = useCallback(
    (swiper: SwiperClass) => setSwiper1(swiper),
    []
  )

  const handleSetSwiper2Instance = useCallback(
    (swiper: SwiperClass) => setSwiper2(swiper),
    []
  )

  const handleNextSlide = useCallback(() => swiper1?.slideNext(), [swiper1])

  const handlePrevSlide = useCallback(() => swiper1?.slidePrev(), [swiper1])

  const handlePagination = useCallback(
    (index: number) => swiper1?.slideTo(index - 1, 500),
    [activeIndex, swiper1]
  )

  const handleSetActiveIndex = useCallback(
    (index: number) => setActiveIndex(index),
    []
  )

  return {
    activeIndex,
    handleNextSlide,
    handlePagination,
    handlePrevSlide,
    handleSetActiveIndex,
    handleSetSwiper2Instance,
    handleSetSwiperInstance,
    swiper1,
    swiper2,
  }
}
